/* @ngInject */
const areaLabels = () => {
  const self = {}

  self.class = 'Zone'
  self.title = 'Zones'

  self.fields = {
    id: {
      text: 'Id',
      mesages: {
        invalid: 'L\'id est invalide',
      },
    },
    isReal: {
      text: 'Réelle',
    },
    selectArea: {
      text: 'Zone',
      choice: 'Choix de la zone',
    },
    name: {
      text: 'Nom',
      messages: {
        invalid: 'Le nom est invalide',
        exists: 'Ce nom de zone existe déjà',
      },
    },
    totalLength: {
      text: 'Longueur totale (m)',
    },
    usedLength: {
      text: 'Longueur utilisée (m)',
    },
    availableLength: {
      text: 'Longueur disponible (m)',
    },
    railwayNumber: {
      text: 'Nombre de voie',
    },
  }

  self.statements = {
    noRailOnArea: 'Aucune voie n\'est enregistrée sur la zone',
    list: 'Liste des zones',
    new: 'Nouvelle Zone',
    edit: 'Modifier la zone',
    label: (_size = 0, _point = false) => {
      return 'Zone' + (_size > 1 ? 's' : '') + (_point ? ' : ' : '')
    },
  }

  self.ask = {
    delete: 'Êtes-vous sûr de vouloir supprimer cette zone ?',
  }

  self.log = {
    save: {
      success: 'La zone a bien été créée.',
      failure: 'Une erreur est survenue lors de la création de la zone.',
      alreadyExists: 'Cette zone existe déjà.',
    },
    update: {
      success: 'La zone a bien été modifiée.',
      failure: 'Une erreur est survenue lors de la modification de la zone.',
    },
    delete: {
      success: 'La zone a bien été supprimée.',
      failure: 'Une erreur a interrompu la suppression de la zone.',
      railwayOnArea: 'Suppression impossible : il existe encore des voies situées sur cette zone.',
      arrivalArea: 'Il est impossible de supprimer la zone d\'arrivée.',
      departureArea: 'Il est impossible de supprimer la zone de départ.',
    },
    search: {
      success: (_length = 0) => {
        if (_length === 0) {
          return 'Aucune zone ne correspond à la recherche.'
        } else if (_length === 1) {
          return '1 zone a été trouvée.'
        } else if (_length > 1) {
          return _length + ' zones ont été trouvées.'
        }
        return 'Zone recherchée.'
      },
      failure: 'Une erreur est survenue durant la recherche des zones.',
      noResult: 'Aucune zone ne correspond à cette recherche.',
      noResultWithId: 'Aucune zone ne correspond à cet identifiant.',
    },
  }

  return self
}

export default areaLabels



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/rails/area/resources/labels.resource.js